import { createApiSlice } from 'app/createApiSlice'
import { API_SCHEMA, API_SCHEMA_SHARE } from 'utils/apiList'

export const schemaListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'schemaList/api',
  endpoints(builder) {
    return {
      // GET: Fetch all schemas with pagination
      fetchSchemas: builder.query({
        query({ page = 0, size = 10, sortby = 'id', sortdir = 'ASC', s }) {
          return {
            url: `/${API_SCHEMA}`,
            params: {
              page,
              size,
              sortby,
              sortdir,
              s,
            },
          }
        },
      }),
      shareSchema: builder.mutation({
        query(data) {
          return {
            url: API_SCHEMA_SHARE,
            method: 'POST',
            body: data,
          }
        },
      }),
    }
  },
})

export const {
  useFetchSchemasQuery,
  useLazyFetchSchemasQuery,
  useShareSchemaMutation,
} = schemaListApiSlice
